module.exports = __webpack_public_path__ + "static/media/arrow-back.3236613c.svg";